import { render } from "./LavoriAggiuntiviPage.vue?vue&type=template&id=4cae5e99"
import script from "./LavoriAggiuntiviPage.vue?vue&type=script&lang=js"
export * from "./LavoriAggiuntiviPage.vue?vue&type=script&lang=js"

import "./LavoriAggiuntiviPage.vue?vue&type=style&index=0&id=4cae5e99&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__